import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styled, {css} from "styled-components";
import './index.scss';

const Index = ({children, className, calc, disabled}) => {
  const classNames = cx(
    'bb-board',
    disabled ? 'bb-board-disable' : '',
    className,
  );
  return (
    <BoardWrap className={classNames} {...{calc}}>{children}</BoardWrap>
  );
};

Index.propTypes = {
    className: PropTypes.string,
    calc: PropTypes.number
};
Index.defaultProps = {
    className: '',
    calc: 0
};

const BoardWrap = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 10px;
  ${props => css`
    height: calc(100vh - ${props.calc}px)
  `}
`;

export default Index;